import { ApexAccountDev } from '../../../investment/components/account/ApexAccountDev';

export default function AccountDevPage() {
    return <ApexAccountDev />;
}
